import { compose } from 'recompose';


import withShopifyConnectionSave from '../ShopifySettingsForm/withShopifyConnectionSave';
import withNotifications from '../../../../../common/withNotifications';
import ShopifySettingsPage from './ShopifySettingsPage';

export default compose(
  withNotifications,
  withShopifyConnectionSave,
)(ShopifySettingsPage);
